import "core-js/modules/es.array.concat.js";
import QRCode from 'qrcodejs2';
import http from '@/utils/http';
import { Search } from '@element-plus/icons-vue';
export default {
  setup: function setup() {
    return {
      Search: Search
    };
  },
  components: {
    Search: Search
  },
  data: function data() {
    return {
      customerData: [],
      //公司数据
      bwidth: true,
      //判断页面的宽度
      ewmShow: false,
      //二维码链接显示状态
      // 页面修改新增验证规则
      rules: {
        company: [{
          required: true,
          message: '公司名称不能为空',
          trigger: 'blur'
        }],
        lxr: [{
          required: true,
          message: '联系人不能为空',
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          message: '手机号不能为空',
          trigger: 'blur'
        }]
      },
      bus: {
        company: '',
        lxr: '',
        phone: '',
        url: '' //链接

      },
      bus1: {
        company: '深圳市劲拓自动化设备股份有限公司',
        lxr: '毛一静',
        phone: '13603083306',
        url: '' //链接

      }
    };
  },
  created: function created() {
    this.customerList(); //客户信息

    if (window.screen.availWidth < 800) {
      //判断屏幕小于800时
      this.bwidth = false;
    }
  },
  methods: {
    // 客户数据
    customerList: function customerList() {
      var _this = this;

      http.get("/oa/customer").then(function (res) {
        var _res$data = res.data,
            data = _res$data.data,
            code = _res$data.code;

        if (200 == code) {
          _this.customerData = data;
        }
      });
    },
    // 点击生成
    onSubmit: function onSubmit() {
      var _this2 = this;

      this.$refs.ruleFormRef.validate(function (valid) {
        if (valid == false) {
          return;
        } else {
          if (_this2.ewmShow) {
            _this2.$refs.exCodeRef.innerHTML = "";
          }

          _this2.ewmShow = true;
          var _this2$bus = _this2.bus,
              phone = _this2$bus.phone,
              company = _this2$bus.company,
              lxr = _this2$bus.lxr;

          _this2.$nextTick(function () {
            // let sun =`http://oa.smtjhd.com:6066/survey/index.html#/login?company=${company}&lxr=${lxr}&dh=${phone}`
            var sun = "http://gitea.smtjhd.com/wechat/index.html#pages/shouquan/shouquan?company=".concat(company, "&lxr=").concat(lxr, "&dh=").concat(phone);
            _this2.bus.url = sun;
            var qrcode = new QRCode(document.getElementById('ewm1'), {
              text: sun,
              width: 150,
              height: 150,
              correctLevel: QRCode.CorrectLevel.L
            });
          });
        }
      });
    }
  }
};